import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendLandingPageAsset,
  BackendMutationCreateContinuousOptimizationLandingPageAssetArgs,
} from 'src/types/backend';

import { FRAGMENT_CO_ASSET } from './schema';

const MUTATION = gql`
  mutation CreateCOAsset(
    $projectId: ID!
    $cssSelector: String!
    $continuousOptimizationSegmentId: ID
  ) {
    createContinuousOptimizationLandingPageAsset(
      projectId: $projectId
      cssSelector: $cssSelector
      continuousOptimizationSegmentId: $continuousOptimizationSegmentId
    ) {
      ...LandingPageAsset
    }
  }
  ${FRAGMENT_CO_ASSET}
`;

type Variables = Pick<
  BackendMutationCreateContinuousOptimizationLandingPageAssetArgs,
  'projectId' | 'cssSelector' | 'continuousOptimizationSegmentId'
>;

type Result = BackendLandingPageAsset;

export const createCOAsset = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
